// src/lib/i18n.js
// Translation strings for all supported languages

export const LANGUAGES = [
  { code: 'en', label: 'English',    flag: '🇨🇦' },
  { code: 'es', label: 'Español',    flag: '🇪🇸' },
  { code: 'fr', label: 'Français',   flag: '🇫🇷' },
  { code: 'pt', label: 'Português',  flag: '🇧🇷' },
  { code: 'ar', label: 'العربية',    flag: '🇦🇪' },
  { code: 'zh', label: '中文',        flag: '🇨🇳' },
  { code: 'de', label: 'Deutsch',    flag: '🇩🇪' },
  { code: 'ja', label: '日本語',      flag: '🇯🇵' },
  { code: 'ru', label: 'Русский',    flag: '🇷🇺' },
  { code: 'yo', label: 'Yorùbá',     flag: '🇳🇬' },
];

export const TRANSLATIONS = {
  en: {
    // BrandHome (added for live language switching)
    nav_home: 'Home',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: 'Trading Resources',
    nav_aboutOdf: 'About ODF',
    nav_contact: 'Contact',
    nav_enterPerformanceLab: 'Enter Performance Lab',
    brand_pillTagline: 'ODFTrades · An All-in-One Trading Platform',
    brand_heroSubhead: 'ODFTrades is an educational trading platform and software company founded by ODF, bringing together trading resources, market-learning content, and practical tools for traders who want structure, clarity, and long-term growth.',
    // Nav
    features: 'Features',
    about: 'About',
    faq: 'FAQ',
    contact: 'Contact',
    signIn: 'Sign In',
    dashboard: 'Dashboard →',
    trackRecord: 'Trade Data Analytics',
    // Hero
    heroHeadline: 'The OS for Serious Traders.',
    heroHeadline2: 'Built by a Trader. Trusted by Your Data.',
    heroSub: 'Most platforms track trades. ODFTrades builds better traders — through performance coaching, deep diagnostics, and a system designed around how serious traders actually work. Built by ODF after years of manual tracking failing to create consistency.',
    startFree: 'Start Tracking Free',
    viewTrackRecord: 'View Trade Data Analytics →',
    // Problem
    problemTag: 'The problem',
    problemHeadline: 'Performance cannot improve without measurement.',
    problemSub: 'Most traders operate without real data. Decisions driven by emotion, patterns never identified, mistakes repeated indefinitely.',
    // Solution
    solutionTag: 'The solution',
    solutionHeadline: 'ODFTrades gives you the data to trade with precision.',
    solutionSub: 'Structured trade logging. Real performance analytics. Discipline tracking. Risk control. Everything a serious trader needs in one place.',
    // Features
    featuresTag: 'Core system',
    featuresHeadline: 'Everything in one system.',
    // CTA
    ctaHeadline: 'Track your performance',
    ctaHeadline2: 'like a professional.',
    ctaSub: 'If you are serious about trading, this is the system you need.',
    startFreeBtn: 'Start Free →',
    // Footer
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    disclaimer: 'Disclaimer',
    contactUs: 'Contact',
    rights: 'All rights reserved',

    // ── Extended UI strings ──
    signOut: 'Sign Out',
    dashboard_label: 'Dashboard',
    nav_dashboard: 'Dashboard',
    nav_journal: 'Journal',
    nav_newTrade: 'New Trade',
    nav_calendar: 'Calendar',
    nav_markets: 'Markets',
    nav_calculator: 'Calculator',
    nav_risk: 'Risk Manager',
    nav_discipline: 'Discipline',
    nav_import: 'Import / Export',
    nav_lab: 'Performance Lab',
    nav_settings: 'Settings',
    stat_winRate: 'Win Rate',
    stat_roi: 'ROI',
    stat_totalTrades: 'Total Trades',
    stat_avgRR: 'Avg RR',
    stat_profitFactor: 'Profit Factor',
    stat_discipline: 'Discipline',
    stat_maxDrawdown: 'Max Drawdown',
    stat_bestDay: 'Best Day',
    stat_totalPnl: 'Total P&L',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    submit: 'Submit',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    loading: 'Loading...',
    field_pair: 'Pair',
    field_direction: 'Direction',
    field_result: 'Result',
    field_entry: 'Entry Price',
    field_stopLoss: 'Stop Loss',
    field_takeProfit: 'Take Profit',
    field_lotSize: 'Lot Size',
    field_pnl: 'P&L',
    field_session: 'Session',
    field_date: 'Date',
    field_notes: 'Notes',
    field_rr: 'RR Achieved',
    win: 'Win',
    loss: 'Loss',
    breakeven: 'Breakeven',
    ongoing: 'Ongoing',
    buy: 'Buy',
    sell: 'Sell',
    page_newTrade: 'New Trade',
    page_journal: 'Journal',
    page_calendar: 'Calendar',
    page_markets: 'Markets',
    page_settings: 'Settings',
    page_lab: 'Performance Lab',
    empty_noTrades: 'No trades yet. Log your first trade to get started.',
  },
  es: {
    // BrandHome (added for live language switching)
    nav_home: 'Inicio',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: 'Recursos de Trading',
    nav_aboutOdf: 'Sobre ODF',
    nav_contact: 'Contacto',
    nav_enterPerformanceLab: 'Entrar a Performance Lab',
    brand_pillTagline: 'ODFTrades · Una plataforma de trading todo en uno',
    brand_heroSubhead: 'ODFTrades es una plataforma de trading educativa y empresa de software fundada por ODF, que reúne recursos de trading, contenido de aprendizaje de mercado y herramientas prácticas para traders que buscan estructura, claridad y crecimiento a largo plazo.',
    features: 'Características',
    about: 'Acerca de',
    faq: 'FAQ',
    contact: 'Contacto',
    signIn: 'Iniciar Sesión',
    dashboard: 'Panel →',
    trackRecord: 'Historial',
    heroHeadline: 'Ejecución Primero.',
    heroHeadline2: 'Rendimiento Siempre.',
    heroSub: 'ODFTrades es un sistema profesional de rendimiento de trading construido para traders que miden la ejecución, no las suposiciones.',
    startFree: 'Comenzar Gratis',
    viewTrackRecord: 'Ver Historial →',
    problemTag: 'El problema',
    problemHeadline: 'El rendimiento no puede mejorar sin medición.',
    problemSub: 'La mayoría de los traders operan sin datos reales. Decisiones impulsadas por emociones, patrones nunca identificados, errores repetidos indefinidamente.',
    solutionTag: 'La solución',
    solutionHeadline: 'ODFTrades te da los datos para operar con precisión.',
    solutionSub: 'Registro estructurado de operaciones. Análisis real del rendimiento. Seguimiento de disciplina. Control de riesgo.',
    featuresTag: 'Sistema principal',
    featuresHeadline: 'Todo en un sistema.',
    ctaHeadline: 'Rastrea tu rendimiento',
    ctaHeadline2: 'como un profesional.',
    ctaSub: 'Si eres serio con el trading, este es el sistema que necesitas.',
    startFreeBtn: 'Comenzar →',
    privacy: 'Política de Privacidad',
    terms: 'Términos de Servicio',
    disclaimer: 'Aviso Legal',
    contactUs: 'Contacto',
    rights: 'Todos los derechos reservados',

    // ── Extended UI strings ──
    signOut: 'Cerrar Sesión',
    dashboard_label: 'Panel',
    nav_dashboard: 'Panel',
    nav_journal: 'Diario',
    nav_newTrade: 'Nueva Operación',
    nav_calendar: 'Calendario',
    nav_markets: 'Mercados',
    nav_calculator: 'Calculadora',
    nav_risk: 'Gestor Riesgo',
    nav_discipline: 'Disciplina',
    nav_import: 'Importar/Exportar',
    nav_lab: 'Laboratorio',
    nav_settings: 'Ajustes',
    stat_winRate: 'Tasa Acierto',
    stat_roi: 'ROI',
    stat_totalTrades: 'Total Operaciones',
    stat_avgRR: 'RR Promedio',
    stat_profitFactor: 'Factor Beneficio',
    stat_discipline: 'Disciplina',
    stat_maxDrawdown: 'Drawdown Máx',
    stat_bestDay: 'Mejor Día',
    stat_totalPnl: 'P&G Total',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    submit: 'Enviar',
    confirm: 'Confirmar',
    back: 'Atrás',
    next: 'Siguiente',
    loading: 'Cargando...',
    field_pair: 'Par',
    field_direction: 'Dirección',
    field_result: 'Resultado',
    field_entry: 'Precio Entrada',
    field_stopLoss: 'Stop Loss',
    field_takeProfit: 'Take Profit',
    field_lotSize: 'Tamaño Lote',
    field_pnl: 'P&G',
    field_session: 'Sesión',
    field_date: 'Fecha',
    field_notes: 'Notas',
    field_rr: 'RR Logrado',
    win: 'Ganada',
    loss: 'Pérdida',
    breakeven: 'Equilibrio',
    ongoing: 'En Curso',
    buy: 'Compra',
    sell: 'Venta',
    page_newTrade: 'Nueva Operación',
    page_journal: 'Diario',
    page_calendar: 'Calendario',
    page_markets: 'Mercados',
    page_settings: 'Ajustes',
    page_lab: 'Laboratorio',
    empty_noTrades: 'Sin operaciones aún. Registra tu primera operación para comenzar.',
  },
  fr: {
    // BrandHome (added for live language switching)
    nav_home: 'Accueil',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: 'Ressources de Trading',
    nav_aboutOdf: 'À propos d’ODF',
    nav_contact: 'Contact',
    nav_enterPerformanceLab: 'Accéder à Performance Lab',
    brand_pillTagline: 'ODFTrades · Une plateforme de trading tout-en-un',
    brand_heroSubhead: 'ODFTrades est une plateforme de trading éducative et une société de logiciels fondée par ODF, rassemblant des ressources de trading, du contenu d’apprentissage de marché et des outils pratiques pour les traders qui recherchent structure, clarté et croissance à long terme.',
    features: 'Fonctionnalités',
    about: 'À propos',
    faq: 'FAQ',
    contact: 'Contact',
    signIn: 'Se connecter',
    dashboard: 'Tableau de bord →',
    trackRecord: 'Historique',
    heroHeadline: "L'exécution d'abord.",
    heroHeadline2: 'La performance toujours.',
    heroSub: "ODFTrades est un système professionnel de performance de trading conçu pour les traders qui mesurent l'exécution.",
    startFree: 'Commencer gratuitement',
    viewTrackRecord: "Voir l'historique →",
    problemTag: 'Le problème',
    problemHeadline: 'La performance ne peut pas s\'améliorer sans mesure.',
    problemSub: 'La plupart des traders opèrent sans données réelles. Décisions émotionnelles, erreurs répétées.',
    solutionTag: 'La solution',
    solutionHeadline: 'ODFTrades vous donne les données pour trader avec précision.',
    solutionSub: 'Journalisation structurée. Analytique réelle. Suivi de discipline. Contrôle des risques.',
    featuresTag: 'Système principal',
    featuresHeadline: 'Tout en un système.',
    ctaHeadline: 'Suivez vos performances',
    ctaHeadline2: 'comme un professionnel.',
    ctaSub: 'Si vous êtes sérieux dans le trading, c\'est le système qu\'il vous faut.',
    startFreeBtn: 'Commencer →',
    privacy: 'Politique de confidentialité',
    terms: 'Conditions d\'utilisation',
    disclaimer: 'Avertissement',
    contactUs: 'Contact',
    rights: 'Tous droits réservés',

    // ── Extended UI strings ──
    signOut: 'Déconnexion',
    dashboard_label: 'Tableau de Bord',
    nav_dashboard: 'Tableau de Bord',
    nav_journal: 'Journal',
    nav_newTrade: 'Nouveau Trade',
    nav_calendar: 'Calendrier',
    nav_markets: 'Marchés',
    nav_calculator: 'Calculatrice',
    nav_risk: 'Gestion Risque',
    nav_discipline: 'Discipline',
    nav_import: 'Importer/Exporter',
    nav_lab: 'Laboratoire',
    nav_settings: 'Paramètres',
    stat_winRate: 'Taux Réussite',
    stat_roi: 'ROI',
    stat_totalTrades: 'Total Trades',
    stat_avgRR: 'RR Moyen',
    stat_profitFactor: 'Facteur Profit',
    stat_discipline: 'Discipline',
    stat_maxDrawdown: 'Drawdown Max',
    stat_bestDay: 'Meilleur Jour',
    stat_totalPnl: 'P&P Total',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    submit: 'Soumettre',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    loading: 'Chargement...',
    field_pair: 'Paire',
    field_direction: 'Direction',
    field_result: 'Résultat',
    field_entry: 'Prix Entrée',
    field_stopLoss: 'Stop Loss',
    field_takeProfit: 'Take Profit',
    field_lotSize: 'Taille Lot',
    field_pnl: 'P&P',
    field_session: 'Session',
    field_date: 'Date',
    field_notes: 'Notes',
    field_rr: 'RR Atteint',
    win: 'Gagné',
    loss: 'Perdu',
    breakeven: 'Neutre',
    ongoing: 'En Cours',
    buy: 'Achat',
    sell: 'Vente',
    page_newTrade: 'Nouveau Trade',
    page_journal: 'Journal',
    page_calendar: 'Calendrier',
    page_markets: 'Marchés',
    page_settings: 'Paramètres',
    page_lab: 'Laboratoire',
    empty_noTrades: 'Aucun trade pour le moment. Enregistrez votre premier trade pour commencer.',
  },
  pt: {
    // BrandHome (added for live language switching)
    nav_home: 'Início',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: 'Recursos de Trading',
    nav_aboutOdf: 'Sobre ODF',
    nav_contact: 'Contato',
    nav_enterPerformanceLab: 'Entrar no Performance Lab',
    brand_pillTagline: 'ODFTrades · Uma plataforma de trading tudo-em-um',
    brand_heroSubhead: 'ODFTrades é uma plataforma educativa de trading e empresa de software fundada por ODF, reunindo recursos de trading, conteúdo de aprendizado de mercado e ferramentas práticas para traders que buscam estrutura, clareza e crescimento de longo prazo.',
    features: 'Recursos',
    about: 'Sobre',
    faq: 'FAQ',
    contact: 'Contato',
    signIn: 'Entrar',
    dashboard: 'Painel →',
    trackRecord: 'Histórico',
    heroHeadline: 'Execução Primeiro.',
    heroHeadline2: 'Performance Sempre.',
    heroSub: 'ODFTrades é um sistema profissional de performance de trading construído para traders que medem execução.',
    startFree: 'Começar Grátis',
    viewTrackRecord: 'Ver Histórico →',
    problemTag: 'O problema',
    problemHeadline: 'A performance não pode melhorar sem medição.',
    problemSub: 'A maioria dos traders opera sem dados reais. Decisões emocionais, erros repetidos indefinidamente.',
    solutionTag: 'A solução',
    solutionHeadline: 'ODFTrades dá os dados para operar com precisão.',
    solutionSub: 'Registro estruturado. Análise real. Rastreamento de disciplina. Controle de risco.',
    featuresTag: 'Sistema principal',
    featuresHeadline: 'Tudo em um sistema.',
    ctaHeadline: 'Rastreie sua performance',
    ctaHeadline2: 'como um profissional.',
    ctaSub: 'Se você é sério no trading, este é o sistema que você precisa.',
    startFreeBtn: 'Começar →',
    privacy: 'Política de Privacidade',
    terms: 'Termos de Serviço',
    disclaimer: 'Aviso Legal',
    contactUs: 'Contato',
    rights: 'Todos os direitos reservados',

    // ── Extended UI strings ──
    signOut: 'Sair',
    dashboard_label: 'Painel',
    nav_dashboard: 'Painel',
    nav_journal: 'Diário',
    nav_newTrade: 'Nova Operação',
    nav_calendar: 'Calendário',
    nav_markets: 'Mercados',
    nav_calculator: 'Calculadora',
    nav_risk: 'Gerenciador Risco',
    nav_discipline: 'Disciplina',
    nav_import: 'Importar/Exportar',
    nav_lab: 'Laboratório',
    nav_settings: 'Configurações',
    stat_winRate: 'Taxa Acerto',
    stat_roi: 'ROI',
    stat_totalTrades: 'Total Operações',
    stat_avgRR: 'RR Médio',
    stat_profitFactor: 'Fator Lucro',
    stat_discipline: 'Disciplina',
    stat_maxDrawdown: 'Drawdown Máx',
    stat_bestDay: 'Melhor Dia',
    stat_totalPnl: 'L&P Total',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    submit: 'Enviar',
    confirm: 'Confirmar',
    back: 'Voltar',
    next: 'Próximo',
    loading: 'Carregando...',
    field_pair: 'Par',
    field_direction: 'Direção',
    field_result: 'Resultado',
    field_entry: 'Preço Entrada',
    field_stopLoss: 'Stop Loss',
    field_takeProfit: 'Take Profit',
    field_lotSize: 'Tamanho Lote',
    field_pnl: 'L&P',
    field_session: 'Sessão',
    field_date: 'Data',
    field_notes: 'Notas',
    field_rr: 'RR Alcançado',
    win: 'Ganho',
    loss: 'Perda',
    breakeven: 'Empate',
    ongoing: 'Em Andamento',
    buy: 'Compra',
    sell: 'Venda',
    page_newTrade: 'Nova Operação',
    page_journal: 'Diário',
    page_calendar: 'Calendário',
    page_markets: 'Mercados',
    page_settings: 'Configurações',
    page_lab: 'Laboratório',
    empty_noTrades: 'Sem operações ainda. Registre sua primeira operação para começar.',
  },
  ar: {
    // BrandHome (added for live language switching)
    nav_home: 'الرئيسية',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: 'موارد التداول',
    nav_aboutOdf: 'عن ODF',
    nav_contact: 'تواصل معنا',
    nav_enterPerformanceLab: 'الدخول إلى Performance Lab',
    brand_pillTagline: 'ODFTrades · منصة تداول شاملة',
    brand_heroSubhead: 'ODFTrades هي منصة تداول تعليمية وشركة برمجيات أسسها ODF، تجمع موارد التداول ومحتوى تعلم الأسواق وأدوات عملية للمتداولين الذين يبحثون عن البنية والوضوح والنمو على المدى الطويل.',
    features: 'المميزات',
    about: 'عن المنصة',
    faq: 'الأسئلة الشائعة',
    contact: 'تواصل معنا',
    signIn: 'تسجيل الدخول',
    dashboard: 'لوحة التحكم →',
    trackRecord: 'سجل الأداء',
    heroHeadline: 'التنفيذ أولاً.',
    heroHeadline2: 'الأداء دائماً.',
    heroSub: 'ODFTrades نظام احترافي لأداء التداول مبني للمتداولين الجادين.',
    startFree: 'ابدأ مجاناً',
    viewTrackRecord: 'عرض سجل الأداء →',
    problemTag: 'المشكلة',
    problemHeadline: 'لا يمكن تحسين الأداء بدون قياس.',
    problemSub: 'معظم المتداولين يعملون بدون بيانات حقيقية. قرارات عاطفية، أخطاء متكررة.',
    solutionTag: 'الحل',
    solutionHeadline: 'ODFTrades يمنحك البيانات للتداول بدقة.',
    solutionSub: 'تسجيل منظم. تحليلات حقيقية. تتبع الانضباط. إدارة المخاطر.',
    featuresTag: 'النظام الأساسي',
    featuresHeadline: 'كل شيء في نظام واحد.',
    ctaHeadline: 'تتبع أداءك',
    ctaHeadline2: 'كالمحترفين.',
    ctaSub: 'إذا كنت جاداً في التداول، هذا هو النظام الذي تحتاجه.',
    startFreeBtn: 'ابدأ الآن →',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الخدمة',
    disclaimer: 'إخلاء المسؤولية',
    contactUs: 'تواصل معنا',
    rights: 'جميع الحقوق محفوظة',

    // ── Extended UI strings ──
    signOut: 'خروج',
    dashboard_label: 'لوحة التحكم',
    nav_dashboard: 'لوحة التحكم',
    nav_journal: 'السجل',
    nav_newTrade: 'صفقة جديدة',
    nav_calendar: 'التقويم',
    nav_markets: 'الأسواق',
    nav_calculator: 'الحاسبة',
    nav_risk: 'إدارة المخاطر',
    nav_discipline: 'الانضباط',
    nav_import: 'استيراد/تصدير',
    nav_lab: 'مختبر الأداء',
    nav_settings: 'الإعدادات',
    stat_winRate: 'نسبة الفوز',
    stat_roi: 'العائد',
    stat_totalTrades: 'إجمالي الصفقات',
    stat_avgRR: 'متوسط R/R',
    stat_profitFactor: 'عامل الربح',
    stat_discipline: 'الانضباط',
    stat_maxDrawdown: 'أقصى تراجع',
    stat_bestDay: 'أفضل يوم',
    stat_totalPnl: 'إجمالي الربح/الخسارة',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    submit: 'إرسال',
    confirm: 'تأكيد',
    back: 'رجوع',
    next: 'التالي',
    loading: 'تحميل...',
    field_pair: 'الزوج',
    field_direction: 'الاتجاه',
    field_result: 'النتيجة',
    field_entry: 'سعر الدخول',
    field_stopLoss: 'وقف الخسارة',
    field_takeProfit: 'جني الأرباح',
    field_lotSize: 'حجم اللوت',
    field_pnl: 'الربح/الخسارة',
    field_session: 'الجلسة',
    field_date: 'التاريخ',
    field_notes: 'ملاحظات',
    field_rr: 'R/R المحقق',
    win: 'ربح',
    loss: 'خسارة',
    breakeven: 'تعادل',
    ongoing: 'جارية',
    buy: 'شراء',
    sell: 'بيع',
    page_newTrade: 'صفقة جديدة',
    page_journal: 'السجل',
    page_calendar: 'التقويم',
    page_markets: 'الأسواق',
    page_settings: 'الإعدادات',
    page_lab: 'مختبر الأداء',
    empty_noTrades: 'لا توجد صفقات بعد. سجل صفقتك الأولى للبدء.',
  },
  zh: {
    // BrandHome (added for live language switching)
    nav_home: '首页',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: '交易资源',
    nav_aboutOdf: '关于 ODF',
    nav_contact: '联系',
    nav_enterPerformanceLab: '进入 Performance Lab',
    brand_pillTagline: 'ODFTrades · 一站式交易平台',
    brand_heroSubhead: 'ODFTrades 是一家由 ODF 创立的教育型交易平台与软件公司，汇集交易资源、市场学习内容和实用工具，服务于追求结构、清晰度和长期成长的交易者。',
    features: '功能特点',
    about: '关于我们',
    faq: '常见问题',
    contact: '联系我们',
    signIn: '登录',
    dashboard: '仪表板 →',
    trackRecord: '交易记录',
    heroHeadline: '执行第一。',
    heroHeadline2: '业绩永远。',
    heroSub: 'ODFTrades是专为认真衡量执行力的交易者打造的专业交易绩效系统。',
    startFree: '免费开始',
    viewTrackRecord: '查看交易记录 →',
    problemTag: '问题所在',
    problemHeadline: '没有衡量就无法提升业绩。',
    problemSub: '大多数交易者在没有真实数据的情况下操作。情绪化决策，反复犯错。',
    solutionTag: '解决方案',
    solutionHeadline: 'ODFTrades为您提供精确交易所需的数据。',
    solutionSub: '结构化交易记录。真实绩效分析。纪律追踪。风险控制。',
    featuresTag: '核心系统',
    featuresHeadline: '一个系统，全面覆盖。',
    ctaHeadline: '像专业人士一样',
    ctaHeadline2: '追踪您的业绩。',
    ctaSub: '如果您认真对待交易，这就是您需要的系统。',
    startFreeBtn: '立即开始 →',
    privacy: '隐私政策',
    terms: '服务条款',
    disclaimer: '免责声明',
    contactUs: '联系我们',
    rights: '版权所有',

    // ── Extended UI strings ──
    signOut: '退出',
    dashboard_label: '仪表板',
    nav_dashboard: '仪表板',
    nav_journal: '日志',
    nav_newTrade: '新交易',
    nav_calendar: '日历',
    nav_markets: '市场',
    nav_calculator: '计算器',
    nav_risk: '风险管理',
    nav_discipline: '纪律',
    nav_import: '导入/导出',
    nav_lab: '性能实验室',
    nav_settings: '设置',
    stat_winRate: '胜率',
    stat_roi: '回报率',
    stat_totalTrades: '总交易数',
    stat_avgRR: '平均盈亏比',
    stat_profitFactor: '盈利因子',
    stat_discipline: '纪律',
    stat_maxDrawdown: '最大回撤',
    stat_bestDay: '最佳日',
    stat_totalPnl: '总盈亏',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    submit: '提交',
    confirm: '确认',
    back: '返回',
    next: '下一步',
    loading: '加载中...',
    field_pair: '货币对',
    field_direction: '方向',
    field_result: '结果',
    field_entry: '入场价',
    field_stopLoss: '止损',
    field_takeProfit: '止盈',
    field_lotSize: '手数',
    field_pnl: '盈亏',
    field_session: '时段',
    field_date: '日期',
    field_notes: '备注',
    field_rr: '实际盈亏比',
    win: '盈利',
    loss: '亏损',
    breakeven: '保本',
    ongoing: '进行中',
    buy: '买入',
    sell: '卖出',
    page_newTrade: '新交易',
    page_journal: '日志',
    page_calendar: '日历',
    page_markets: '市场',
    page_settings: '设置',
    page_lab: '性能实验室',
    empty_noTrades: '暂无交易。记录您的第一笔交易开始使用。',
  },
  de: {
    // BrandHome (added for live language switching)
    nav_home: 'Startseite',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: 'Trading-Ressourcen',
    nav_aboutOdf: 'Über ODF',
    nav_contact: 'Kontakt',
    nav_enterPerformanceLab: 'Performance Lab öffnen',
    brand_pillTagline: 'ODFTrades · Eine All-in-One-Trading-Plattform',
    brand_heroSubhead: 'ODFTrades ist eine educational Trading-Plattform und Softwarefirma, gegründet von ODF, die Trading-Ressourcen, Marktlerninhalte und praktische Tools für Trader vereint, die Struktur, Klarheit und langfristiges Wachstum suchen.',
    features: 'Funktionen',
    about: 'Über uns',
    faq: 'FAQ',
    contact: 'Kontakt',
    signIn: 'Anmelden',
    dashboard: 'Dashboard →',
    trackRecord: 'Leistungsnachweis',
    heroHeadline: 'Ausführung zuerst.',
    heroHeadline2: 'Leistung immer.',
    heroSub: 'ODFTrades ist ein professionelles Trading-Performance-System für Trader, die Ausführung messen.',
    startFree: 'Kostenlos starten',
    viewTrackRecord: 'Leistungsnachweis →',
    problemTag: 'Das Problem',
    problemHeadline: 'Leistung kann ohne Messung nicht verbessert werden.',
    problemSub: 'Die meisten Trader arbeiten ohne echte Daten. Emotionale Entscheidungen, wiederholte Fehler.',
    solutionTag: 'Die Lösung',
    solutionHeadline: 'ODFTrades gibt Ihnen die Daten für präzises Trading.',
    solutionSub: 'Strukturiertes Trade-Logging. Echte Performance-Analyse. Disziplin-Tracking. Risikokontrolle.',
    featuresTag: 'Kernsystem',
    featuresHeadline: 'Alles in einem System.',
    ctaHeadline: 'Verfolgen Sie Ihre Leistung',
    ctaHeadline2: 'wie ein Profi.',
    ctaSub: 'Wenn Sie Trading ernst nehmen, ist dies das System, das Sie brauchen.',
    startFreeBtn: 'Jetzt starten →',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen',
    disclaimer: 'Haftungsausschluss',
    contactUs: 'Kontakt',
    rights: 'Alle Rechte vorbehalten',

    // ── Extended UI strings ──
    signOut: 'Abmelden',
    dashboard_label: 'Dashboard',
    nav_dashboard: 'Dashboard',
    nav_journal: 'Journal',
    nav_newTrade: 'Neuer Trade',
    nav_calendar: 'Kalender',
    nav_markets: 'Märkte',
    nav_calculator: 'Rechner',
    nav_risk: 'Risikomanagement',
    nav_discipline: 'Disziplin',
    nav_import: 'Import/Export',
    nav_lab: 'Performance Lab',
    nav_settings: 'Einstellungen',
    stat_winRate: 'Gewinnrate',
    stat_roi: 'ROI',
    stat_totalTrades: 'Trades Insgesamt',
    stat_avgRR: 'Ø CRV',
    stat_profitFactor: 'Profitfaktor',
    stat_discipline: 'Disziplin',
    stat_maxDrawdown: 'Max Drawdown',
    stat_bestDay: 'Bester Tag',
    stat_totalPnl: 'Gesamt G&V',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    submit: 'Senden',
    confirm: 'Bestätigen',
    back: 'Zurück',
    next: 'Weiter',
    loading: 'Laden...',
    field_pair: 'Paar',
    field_direction: 'Richtung',
    field_result: 'Ergebnis',
    field_entry: 'Einstiegspreis',
    field_stopLoss: 'Stop Loss',
    field_takeProfit: 'Take Profit',
    field_lotSize: 'Lot-Größe',
    field_pnl: 'G&V',
    field_session: 'Sitzung',
    field_date: 'Datum',
    field_notes: 'Notizen',
    field_rr: 'Erzieltes CRV',
    win: 'Gewinn',
    loss: 'Verlust',
    breakeven: 'Breakeven',
    ongoing: 'Laufend',
    buy: 'Kauf',
    sell: 'Verkauf',
    page_newTrade: 'Neuer Trade',
    page_journal: 'Journal',
    page_calendar: 'Kalender',
    page_markets: 'Märkte',
    page_settings: 'Einstellungen',
    page_lab: 'Performance Lab',
    empty_noTrades: 'Noch keine Trades. Erfasse deinen ersten Trade, um zu beginnen.',
  },
  ja: {
    // BrandHome (added for live language switching)
    nav_home: 'ホーム',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: 'トレーディングリソース',
    nav_aboutOdf: 'ODFについて',
    nav_contact: 'お問い合わせ',
    nav_enterPerformanceLab: 'Performance Lab を開く',
    brand_pillTagline: 'ODFTrades · オールインワンのトレーディングプラットフォーム',
    brand_heroSubhead: 'ODFTradesは、ODFによって設立された教育的なトレーディングプラットフォーム＆ソフトウェア会社であり、トレーディングのリソース、市場学習コンテンツ、そして構造・明確さ・長期的な成長を求めるトレーダーのための実用的なツールを一つにまとめています。',
    features: '機能',
    about: '概要',
    faq: 'よくある質問',
    contact: 'お問い合わせ',
    signIn: 'サインイン',
    dashboard: 'ダッシュボード →',
    trackRecord: '実績',
    heroHeadline: '執行が最優先。',
    heroHeadline2: 'パフォーマンスは常に。',
    heroSub: 'ODFTradesは、推測ではなく執行を測定するトレーダーのために構築されたプロフェッショナルなトレーディングパフォーマンスシステムです。',
    startFree: '無料で始める',
    viewTrackRecord: '実績を見る →',
    problemTag: '問題',
    problemHeadline: '測定なしにパフォーマンスは向上できません。',
    problemSub: 'ほとんどのトレーダーは実データなしに取引しています。感情的な決断、繰り返されるミス。',
    solutionTag: '解決策',
    solutionHeadline: 'ODFTradesは精密な取引に必要なデータを提供します。',
    solutionSub: '構造化された取引ログ。実際のパフォーマンス分析。規律追跡。リスク管理。',
    featuresTag: 'コアシステム',
    featuresHeadline: '1つのシステムですべてを。',
    ctaHeadline: 'プロのように',
    ctaHeadline2: 'パフォーマンスを追跡。',
    ctaSub: 'トレーディングに真剣なら、これがあなたに必要なシステムです。',
    startFreeBtn: '今すぐ始める →',
    privacy: 'プライバシーポリシー',
    terms: '利用規約',
    disclaimer: '免責事項',
    contactUs: 'お問い合わせ',
    rights: '全著作権所有',

    // ── Extended UI strings ──
    signOut: 'ログアウト',
    dashboard_label: 'ダッシュボード',
    nav_dashboard: 'ダッシュボード',
    nav_journal: 'ジャーナル',
    nav_newTrade: '新規取引',
    nav_calendar: 'カレンダー',
    nav_markets: 'マーケット',
    nav_calculator: '計算機',
    nav_risk: 'リスク管理',
    nav_discipline: '規律',
    nav_import: 'インポート/エクスポート',
    nav_lab: 'パフォーマンスラボ',
    nav_settings: '設定',
    stat_winRate: '勝率',
    stat_roi: 'ROI',
    stat_totalTrades: '総取引数',
    stat_avgRR: '平均RR',
    stat_profitFactor: 'PF',
    stat_discipline: '規律',
    stat_maxDrawdown: '最大DD',
    stat_bestDay: '最高日',
    stat_totalPnl: '総損益',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    submit: '送信',
    confirm: '確認',
    back: '戻る',
    next: '次へ',
    loading: '読込中...',
    field_pair: '通貨ペア',
    field_direction: '方向',
    field_result: '結果',
    field_entry: 'エントリー価格',
    field_stopLoss: 'ストップロス',
    field_takeProfit: 'テイクプロフィット',
    field_lotSize: 'ロットサイズ',
    field_pnl: '損益',
    field_session: 'セッション',
    field_date: '日付',
    field_notes: 'メモ',
    field_rr: '達成RR',
    win: '勝ち',
    loss: '負け',
    breakeven: '建値',
    ongoing: '進行中',
    buy: '買い',
    sell: '売り',
    page_newTrade: '新規取引',
    page_journal: 'ジャーナル',
    page_calendar: 'カレンダー',
    page_markets: 'マーケット',
    page_settings: '設定',
    page_lab: 'パフォーマンスラボ',
    empty_noTrades: 'まだ取引がありません。最初の取引を記録して始めましょう。',
  },
  ru: {
    // BrandHome (added for live language switching)
    nav_home: 'Главная',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: 'Торговые ресурсы',
    nav_aboutOdf: 'Об ODF',
    nav_contact: 'Контакты',
    nav_enterPerformanceLab: 'Войти в Performance Lab',
    brand_pillTagline: 'ODFTrades · Универсальная торговая платформа',
    brand_heroSubhead: 'ODFTrades — это образовательная торговая платформа и софтверная компания, основанная ODF, объединяющая торговые ресурсы, материалы для изучения рынков и практические инструменты для трейдеров, которые стремятся к структуре, ясности и долгосрочному росту.',
    features: 'Функции',
    about: 'О нас',
    faq: 'FAQ',
    contact: 'Контакты',
    signIn: 'Войти',
    dashboard: 'Панель →',
    trackRecord: 'Результаты',
    heroHeadline: 'Исполнение прежде всего.',
    heroHeadline2: 'Результативность всегда.',
    heroSub: 'ODFTrades — профессиональная система торговой эффективности для трейдеров, измеряющих исполнение.',
    startFree: 'Начать бесплатно',
    viewTrackRecord: 'Посмотреть результаты →',
    problemTag: 'Проблема',
    problemHeadline: 'Без измерений нет улучшений.',
    problemSub: 'Большинство трейдеров работают без реальных данных. Эмоциональные решения, повторяющиеся ошибки.',
    solutionTag: 'Решение',
    solutionHeadline: 'ODFTrades даёт данные для точной торговли.',
    solutionSub: 'Структурированный журнал сделок. Реальная аналитика. Дисциплина. Управление рисками.',
    featuresTag: 'Основная система',
    featuresHeadline: 'Всё в одной системе.',
    ctaHeadline: 'Отслеживайте результаты',
    ctaHeadline2: 'как профессионал.',
    ctaSub: 'Если вы серьёзно относитесь к трейдингу, это система для вас.',
    startFreeBtn: 'Начать →',
    privacy: 'Политика конфиденциальности',
    terms: 'Условия использования',
    disclaimer: 'Отказ от ответственности',
    contactUs: 'Контакты',
    rights: 'Все права защищены',

    // ── Extended UI strings ──
    signOut: 'Выйти',
    dashboard_label: 'Панель',
    nav_dashboard: 'Панель',
    nav_journal: 'Журнал',
    nav_newTrade: 'Новая Сделка',
    nav_calendar: 'Календарь',
    nav_markets: 'Рынки',
    nav_calculator: 'Калькулятор',
    nav_risk: 'Риск-Менеджер',
    nav_discipline: 'Дисциплина',
    nav_import: 'Импорт/Экспорт',
    nav_lab: 'Лаборатория',
    nav_settings: 'Настройки',
    stat_winRate: 'Процент Побед',
    stat_roi: 'ROI',
    stat_totalTrades: 'Всего Сделок',
    stat_avgRR: 'Средний RR',
    stat_profitFactor: 'Фактор Прибыли',
    stat_discipline: 'Дисциплина',
    stat_maxDrawdown: 'Макс Просадка',
    stat_bestDay: 'Лучший День',
    stat_totalPnl: 'Общий П&У',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Изменить',
    submit: 'Отправить',
    confirm: 'Подтвердить',
    back: 'Назад',
    next: 'Далее',
    loading: 'Загрузка...',
    field_pair: 'Пара',
    field_direction: 'Направление',
    field_result: 'Результат',
    field_entry: 'Цена Входа',
    field_stopLoss: 'Стоп-Лосс',
    field_takeProfit: 'Тейк-Профит',
    field_lotSize: 'Размер Лота',
    field_pnl: 'П&У',
    field_session: 'Сессия',
    field_date: 'Дата',
    field_notes: 'Заметки',
    field_rr: 'Достигнутый RR',
    win: 'Победа',
    loss: 'Убыток',
    breakeven: 'Безубыток',
    ongoing: 'Открыта',
    buy: 'Покупка',
    sell: 'Продажа',
    page_newTrade: 'Новая Сделка',
    page_journal: 'Журнал',
    page_calendar: 'Календарь',
    page_markets: 'Рынки',
    page_settings: 'Настройки',
    page_lab: 'Лаборатория',
    empty_noTrades: 'Пока нет сделок. Запишите первую сделку, чтобы начать.',
  },
  yo: {
    // BrandHome (added for live language switching)
    nav_home: 'Ilé',
    nav_performanceLab: 'Performance Lab',
    nav_tradingResources: 'Awọn ohun elo Iṣowo',
    nav_aboutOdf: 'Nipa ODF',
    nav_contact: 'Olubasọrọ',
    nav_enterPerformanceLab: 'Wọle si Performance Lab',
    brand_pillTagline: 'ODFTrades · Pẹpẹ iṣowo gbogbo-ninu-ọkan',
    brand_heroSubhead: 'ODFTrades jẹ pẹpẹ ẹkọ iṣowo ati ile-iṣẹ software ti ODF da silẹ, ti o ko awọn ohun elo iṣowo, awọn akoonu ẹkọ ọja, ati awọn irinṣẹ to wulo papọ fun awọn oniṣowo ti o n wa eto, mimọ, ati idagbasoke pipẹ.',
    features: 'Àwọn Ẹya',
    about: 'Nípa Wa',
    faq: 'Àwọn Ìbéèrè',
    contact: 'Kàn Sí Wa',
    signIn: 'Wọlé',
    dashboard: 'Àgbékalẹ̀ →',
    trackRecord: 'Àkọsílẹ̀ Iṣẹ́',
    heroHeadline: 'Ìṣe Ní Àkọ́kọ́.',
    heroHeadline2: 'Iṣẹ́ Àgbára Níjọgbọn.',
    heroSub: 'ODFTrades jẹ ẹ̀rọ iṣẹ́ àgbára ìṣòwò tó ṣe fún àwọn oníṣòwò tó ní ìṣàkóso.',
    startFree: 'Bẹ̀rẹ̀ Lọ́fẹ̀',
    viewTrackRecord: 'Wo Àkọsílẹ̀ →',
    problemTag: 'Ìṣòro',
    problemHeadline: 'Iṣẹ́ kò lè dára láìsí ìwọn.',
    problemSub: 'Ọ̀pọ̀ oníṣòwò ń ṣiṣẹ́ láìsí àlàyé gidi. Àwọn ìpinnu ẹ̀mí, àwọn àṣìṣe tún ṣe.',
    solutionTag: 'Ojútùú',
    solutionHeadline: 'ODFTrades fún ọ ní àlàyé fún ìṣòwò pípéye.',
    solutionSub: 'Àkọsílẹ̀ ìṣòwò. Ìtúpalẹ̀ gidi. Ìtọpinpin ìṣàkóso. Ìṣàkóso ewu.',
    featuresTag: 'Ẹ̀rọ Pàtàkì',
    featuresHeadline: 'Ohun gbogbo nínú ẹ̀rọ kan.',
    ctaHeadline: 'Tọpinpin iṣẹ́ rẹ',
    ctaHeadline2: 'bíi akọ́ṣemọṣe.',
    ctaSub: 'Tí o bá ní ìfẹ́ gidi fún ìṣòwò, èyí ni ẹ̀rọ tí o nílò.',
    startFreeBtn: 'Bẹ̀rẹ̀ →',
    privacy: 'Ìlànà Àṣírí',
    terms: 'Àwọn Ìlànà',
    disclaimer: 'Kíkọ Ojúṣe',
    contactUs: 'Kàn Sí Wa',
    rights: 'Gbogbo ẹ̀tọ́ wà',

    // ── Extended UI strings ──
    signOut: 'Jade',
    dashboard_label: 'Dasibọọdu',
    nav_dashboard: 'Dasibọọdu',
    nav_journal: 'Iwe-Iranti',
    nav_newTrade: 'Iṣowo Tuntun',
    nav_calendar: 'Kalẹnda',
    nav_markets: 'Ọja',
    nav_calculator: 'Ẹrọ Iṣiro',
    nav_risk: 'Olutọju Ewu',
    nav_discipline: 'Ibawi',
    nav_import: 'Gbe Wọle/Jade',
    nav_lab: 'Ile-Iṣẹ Iṣẹ',
    nav_settings: 'Awọn Eto',
    stat_winRate: 'Oṣuwọn Iṣẹgun',
    stat_roi: 'ROI',
    stat_totalTrades: 'Apapọ Iṣowo',
    stat_avgRR: 'RR Apapọ',
    stat_profitFactor: 'Ifosiwewe Èrè',
    stat_discipline: 'Ibawi',
    stat_maxDrawdown: 'Idinku Pupọ',
    stat_bestDay: 'Ọjọ Ti O Dara Julọ',
    stat_totalPnl: 'Apapọ P&L',
    save: 'Fipamọ',
    cancel: 'Fagilee',
    delete: 'Paarẹ',
    edit: 'Ṣatunkọ',
    submit: 'Fi Silẹ',
    confirm: 'Jẹrisi',
    back: 'Pada',
    next: 'Tókàn',
    loading: 'Ngbe...',
    field_pair: 'Tọkọ',
    field_direction: 'Itọsọna',
    field_result: 'Abajade',
    field_entry: 'Idiyele Iwọle',
    field_stopLoss: 'Da Padanu Duro',
    field_takeProfit: 'Gba Èrè',
    field_lotSize: 'Iwọn Pupọ',
    field_pnl: 'P&L',
    field_session: 'Igba',
    field_date: 'Ọjọ',
    field_notes: 'Awọn Akọsilẹ',
    field_rr: 'RR Ti A Ṣaṣeyọri',
    win: 'Iṣẹgun',
    loss: 'Padanu',
    breakeven: 'Dọgba',
    ongoing: 'Nlọ Lọwọ',
    buy: 'Ra',
    sell: 'Ta',
    page_newTrade: 'Iṣowo Tuntun',
    page_journal: 'Iwe-Iranti',
    page_calendar: 'Kalẹnda',
    page_markets: 'Ọja',
    page_settings: 'Awọn Eto',
    page_lab: 'Ile-Iṣẹ Iṣẹ',
    empty_noTrades: 'Ko si iṣowo sibẹsibẹ. Ṣe igbasilẹ iṣowo akọkọ rẹ lati bẹrẹ.',
  },
};

export function t(lang, key) {
  return TRANSLATIONS[lang]?.[key] || TRANSLATIONS['en'][key] || key;
}
